import TagResult from "./TagResult";
import ExamResults from "./ExamResults";
import { AbstractDto, ReadField, ReadWriteField,
    TypedReadField, TypedReadWriteField } from "./AbstractDto";
import ExamPointsCalculator from "./ExamPointsCalculator";
import FinalResultCalculator from "./FinalResultCalculator";

export default class UserResult extends AbstractDto<UserResult> {

    @ReadField
    public _id: any;
    @ReadField
    public readonly repoName: string;
    @ReadField
    public readonly username: string;
    @ReadField
    public firstName: string;
    @ReadField
    public lastName: string;
    @ReadWriteField
    public declarationName: string;
    @ReadField
    public formOfStudy: string;
    @ReadField
    public passwordHash: string;

    @TypedReadField(TagResult)
    public results: TagResult[] = [];

    @ReadField
    public mainScore: number;
    @ReadField
    public latePenalties: number;
    @ReadField
    public reviewPoints: number;
    @ReadField
    public bonusPoints: number;
    @ReadField
    public mainPointsInScale: number;
    @ReadField
    public bonusPointsInScale: number;
    @ReadField
    public isMinimumCompleted: boolean;
    @ReadField
    public codeMatchProblem: string;
    @ReadField
    public preExamRequirementsFilled: boolean = false;
    @ReadField
    public isTestResultConfirmed: boolean = true;
    @ReadField
    public registrationCount: number = 0;
    @ReadWriteField
    public previousGrades: string[];

    @TypedReadWriteField(ExamResults)
    public examResults: ExamResults | undefined;

    @TypedReadWriteField(ExamResults)
    public test1Results: ExamResults | undefined;

    @TypedReadWriteField(ExamResults)
    public test2Results: ExamResults | undefined;

    @ReadWriteField
    public preExamRegistrationId: string | undefined;

    @ReadWriteField
    public dbCredentials: string | undefined;

    getExamResultCalculator(): ExamPointsCalculator {
        return new ExamPointsCalculator(
            this.test1Results,
            this.test2Results, this.examResults);
    }

    getFinalResults(): FinalResultCalculator {
        return new FinalResultCalculator(
            this.mainPointsInScale,
            this.isMinimumCompleted,
            this.getExamResultCalculator().getTotalPoints(),
            this.bonusPointsInScale,
            this.repoName,
            this.getCompletedTags()
        );
    }

    getTest1Results() {
        return this.test1Results || new ExamResults();
    }

    getTest2Results() {
        return this.test2Results || new ExamResults();
    }

    getFinalExamResults() {
        return this.examResults || new ExamResults();
    }

    getResult(tag: string): TagResult | undefined {
        return this.results.filter(each => each.tag === tag)[0];
    }

    getResultOrEmpty(tag: string) : TagResult {
        return this.getResult(tag) || new TagResult(tag);
    }

    getAllTags() : string[] {
        return this.results.map(each => each.tag);
    }

    public getCompletedTags(): string[] {
        return this.results
            .filter(tagResult => tagResult.points && tagResult.points >= tagResult.threshold)
            .map(tagResult => tagResult.tag)
    }

    static create(repoName: string, username: string): UserResult {
        return new UserResult().readRawData({ repoName, username });
    }

    getCiName() {
        return this.firstName + ' ' + this.lastName;
    }

}
